const ko = {
  // Navigation
  nav: {
    about: '회사 소개',
    business: '사업 소개',
    stats: '사례 연구',
    works: '제작 실적',
    news: '뉴스',
    contact: '문의하기',
    values: '기업 이념',
    recruitment: '채용 정보',
    security: '정보 보안',
    topPage: '톱 페이지',
  },
  
  // Services
  services: {
    title: '서비스',
  },
  
  // Footer
  footer: {
    copyright: '© 2026 TradFit Co., Ltd.',
    privacy: '개인정보 보호정책',
  },
  
  // Carousel
  carousel: {
    slide1: {
      title: '생성형 AI로 미래를 창조하다',
      description: '최첨단 AI 기술로 비즈니스의 가능성을 무한히 확장합니다. 데이터에서 가치를 창출하고 혁신적인 솔루션을 제공합니다.'
    },
    slide2: {
      title: '생성형 AI가 이끄는 차세대 비즈니스',
      description: '머신러닝과 딥러닝을 활용하여 기업의 성장을 가속화합니다. 지능적인 의사결정을 지원합니다.'
    },
    slide3: {
      title: '생성형 AI로 혁신을 실현하다',
      description: '생성형 AI 기술로 창의성과 효율성을 양립합니다. 귀하의 비즈니스에 최적화된 AI 솔루션을 맞춤 제공합니다.'
    },
    learnMore: '자세히 보기'
  },
  // Hero
  hero: {
    title: 'TradFit의 미션은 생성형 AI의 힘으로 고객의 비즈니스 프로세스를 재정의하고,',
    subtitle: '고객에게 새로운 가치를 창출하여 "삼방요시(三方よし)"를 실현하는 것입니다.',
    whoAreWe: '[회사 소개]',
    tagline: '업종, 업태, 회사 규모에 관계없이 생성형 AI의 힘으로 고객의 성장을 지원합니다.',
  },
  
  // Footer tagline
  footerTagline: '생성형 AI 및 음성 AI 선도 기업\n도쿄 마루노우치를 거점으로 일본의 과제 해결에 도전하고 있습니다',

  // Home page
  home: {
    heroTitle: '생성형 AI로',
    heroTitleHighlight: '미래를 창조하다',
    heroSubtitle: '최첨단 AI 기술로 비즈니스의 가능성을 무한히 확장합니다. 데이터에서 가치를 창출하고 혁신적인 솔루션을 제공합니다',
    heroCta1: '사업 내용 보기',
    heroCta2: '문의하기',
    missionText: 'TradFit의 미션은 생성형 AI의 힘으로 고객의 비즈니스 프로세스를 재정의하고, 고객에게 새로운 가치를 창출하여 "삼방요시(三方よし)"를 실현하는 것입니다.',
    servicesTag: '우리의 서비스',
    servicesTitle: '혁신을 실현하다',
    servicesSubtitle: '최첨단 AI 기술과 깊은 업계 지식을 결합하여 고객의 비즈니스 과제에 최적화된 솔루션을 제공합니다',
    techTag: '기술',
    techTitle: '당사의 기술 영역',
    techSubtitle: '최첨단 기술을 활용하여 고객의 비즈니스 과제를 다각도로 해결합니다',
    aboutTag: '회사 소개',
    aboutTitle: '일본 비즈니스에 혁신을',
    aboutSubtitle: '도쿄 치요다구 마룦노우치에 본사를 둔 TradFit 주식회사는 2017년 설립 이래, 생성형 AI 및 음성 AI의 선도 기업으로서 DX 추진을 지원합니다',
    aboutText1: '생성 AI·음성 AI 기술과 치밀한 지적재산 전략을 핵심으로 기업의 디지털 트랜스포메이션을 종합적으로 지원합니다',
    aboutText2: '다양한 서비스 라인업으로, 업종·업태·규모를 묻지 않고 고객의 과제 해결에 도전합니다',
    aboutBtn: '회사 개요 보기',
    newsTag: '뉴스',
    newsTitle: '최신 정보',
    newsViewAll: '전체 보기',
    servicesViewAll: '사업 내용 보기',
    ctaTitle: '생성형 AI로 비즈니스를 다음 단계로',
    ctaSubtitle: '부담 없이 상담해 주세요',
    ctaBtn: '문의하기',
    service1Title: '생성형 AI 컨설팅 · 개발 지원',
    service1Desc: '최첨단 생성형 AI 기술을 활용하여 업무 효율화와 혁신 창출을 지원합니다. 전략 수립부터 구현까지 일관 지원합니다',
    service2Title: 'Hospitalia 음성 AI 솔루션',
    service2Desc: '일본 최초 Alexa SP 인증을 받은 음성 AI 플랫폼입니다. 관광·헬스케어·지자체를 위한 업계 특화 솔루션을 제공합니다',
    service3Title: '사이버 보안 서비스',
    service3Desc: '20년 이상 인시던트 제로의 압도적인 실적입니다. AD 서버부터 모든 단말기까지 고객 요구에 맞는 유연한 도입을 실현합니다',
    service4Title: '생성형 AI 마케팅 지원',
    service4Desc: '생성형 AI로 콘텐츠 제작을 혁신합니다. 데이터 기반 타겟팅과 최적화로 마케팅 ROI를 최대화하고 브랜드 가치를 향상시킵니다',
    tech1Title: '생성형 AI',
    tech1Desc: 'LLM·이미지·음성 생성을 활용한 콘텐츠 및 업무 자동화 솔루션',
    tech2Title: '인공지능',
    tech2Desc: '머신러닝·딥러닝·자연어 처리(NLP) 및 기타 AI 기술 전반',
    tech3Title: '로봇공학',
    tech3Desc: '자율 주행 로봇 및 서비스 로봇과의 AI 시스템 연동 및 도입 지원',
    tech4Title: '피지컈 AI',
    tech4Desc: '현실 공간에서 자율적으로 판단·행동하는 AI 시스템 설계 및 구축',
    tech5Title: 'IoT',
    tech5Desc: '스마트 디바이스·센서·클라우드 연동에 의한 실시간 데이터 활용 기반',
    tech6Title: '생체 인증',
    tech6Desc: '성문·얼굴 인식·홍채·지문·정맥 인증에 의한 안전한 본인 확인',
    tech7Title: '빅 데이터',
    tech7Desc: '대규모 데이터 수집·분석·시각화를 통한 데이터 기반 경영 지원',
    tech8Title: '지적재산·특허',
    tech8Desc: 'AI·소프트웨어·비즈니스 모델 관련 다수의 지적재산을 보유',
    learnMore: '자세히 보기',
    newsItem1: '의료 종사자의 부담 경감과 입원 환자 만족도 향상을 목표로 한 음성 보조 병실 개념 검증 실시',
    newsItem2: '전 노무라 증권 전무 이사, 전 노무라 종합연구소 부회장 모모세 히로노리 씨가 TradFit 사의 에그제큐티브 어드바이저로 취임',
    newsItem3: '트래블 보이스 게재. TradFit, NEC Networks & System Integration과 대리점 계약 체결, AI 음성 서비스 "호스피탈리아" 지원 체제 강화',
    newsItem4: 'Alexa Smart Properties를 통한 관광·숙박·의료 산업 및 지자체의 업무 효율화 및 생산성 향상 지원',
  },

  // News hero subtitle
  newsHeroSubtitle: '뉴스·보도자료·이벤트 정보',

  // Language
  language: {
    english: 'English',
    japanese: '日本語',
    korean: '한국어',
    chinese: '繁體中文',
  },

  // About Page
  about: {
    title: '회사 개요',
    subtitle: 'ABOUT US',
    missionTitle: 'TradFit의 미션',
    missionText1: 'TradFit의 미션은 생성형 AI의 힘으로 고객의 비즈니스 프로세스를 재정의하고, 고객에게 새로운 가치를 창출하여 "삼방요시(三方よし)"를 실현하는 것입니다',
    missionText2: '생성형 AI와 비즈니스에 정통한 정예 멤버에 의한 구동, 압도적인 납품 속도, 비즈니스의 수비와 공격을 가속화하는 지식재산 전략으로 국내외 강력한 특허 포트폴리오를 보유하고 있는 것이 강점입니다',
    valuesTitle: 'TradFit의 가치관',
    businessContent: '사업 내용 (국내외 특허 승인 및 출원 중)',
    businessItems: [
      '생성형 AI 컨설팅 사업',
      '생성형 AI 개발 사업',
      '생성형 AI 마케팅 사업',
      '사이버 보안 사업',
      '관광·헬스케어·지자체 대상 음성 AI 솔루션 (Hospitalia)',
    ],
    businessNote: '국내외 특허 취득 완료·출원 중',
    businessContentText: '① 관광·헬스케어·지자체용 음성 AI 솔루션 (Hospitalia) ② 생성형 AI 컨설팅·개발 지원 서비스 ③ 사이버 보안 서비스 ④ 생성형 AI 마케팅 지원 서비스 (음성 AI 데이터 플랫폼 구축 및 운영 포함. 국내외 특허 취득 완료·출원 중)',
    companyInfo: '회사 정보',
    companyName: '회사명',
    companyNameValue: 'TradFit 주식회사',
    companyNameEn: 'TradFit Co., Ltd.',
    established: '설립',
    establishedValue: '2017년 8월',
    capital: '자본금',
    capitalValue: '1억 엔',
    ceo: '대표이사',
    ceoValue: '토다 요시키',
    headquarters: '본사 소재지',
    headquartersPostal: '100-0005',
    headquartersAddress1: '도쿄도 치요다구 마루노우치 1-6-5',
    headquartersAddress2: '마루노우치 키타구치 빌딩 9F',
    contact: '연락처',
    shareholders: '주주',
    shareholdersText: '닛세이 캐피탈 주식회사(일본생명 그룹), GMO 벤처파트너스 주식회사, 주식회사 파소나 그룹, 사업창조 캐피탈 주식회사(NSG 그룹), 경영진 등',
    affiliations: '소속 단체',
    affiliation1: 'AWS 파트너 소프트웨어 패스 국제 인증 취득',
    affiliation2: 'Google Cloud™ Build Partner 국제 인증 취득',
    affiliation3: '일본 숙박업 관련 협회 (JARC)',
    affiliation4: '일본 관광 진흥 협회',
    affiliation5: '도쿄 관광 재단',
    majorClients: '거래처 (일부 발쳐)',
    majorClientsText: 'IT 업계, 전문직 업계, 개인 사업자, 미용 업계, 브라이달 업계, 학교 법인 업계, 부동산 업계, 철도 업계, 숙박 업계·헬스케어 업계 등',
    partners: '제휴사 (일부 발쳐)',
    partnersText: '국내외 중소기업·중견기업·대기업 등',
    awards: '수상 경력 (일부 발쳐)',
    award1: '니가타현의 혁신적인 스타트업으로서 "J-Startup NIIGATA" 인증',
    award2: '주식회사 트래블 보이스가 선정한 국내외 주목해야 할 기업 10개사 중 하나로 선정',
    award3: '경제산업성/특허청 제3회 "IP BASE AWARD" 장려상(스타트업 부문) 수상',
    award4: 'NIIGATA VENTURE AWARD 2022 최우수상 수상',
    award5: '사단법인 일본 스타트업 지원 협회 주관 "The JSSA MeetUp & Award Vol.39" 최우수상 수상',
    award6: 'APAC CIOoutlook 선정 "2022년 10대 인지 솔루션 제공업체"',
    award7: 'The Silicon Review 선정 "2022년 10대 윤리적 기업"',
    award8: 'The Enterprise World 선정 "올해의 진취적인 기업"',
    award9: '3년 연속 아시아 100대 기업 선정',
    award10: '3년 연속 베스트 벤처 100 선정',
  },

  values: {
    title: '기업 이념',
    subtitle: 'Values',
    sixValues: '6가지 핵심 가치',
    clientFirst: '고객 최우선',
    clientFirstDesc: '우리는 고객의 성공을 무엇보다 우선시합니다. 모든 전략, 모든 결정, 모든 행동은 우리가 봉사하는 대상에게 최대의 가치를 제공하는 것을 목표로 합니다',
    dataDriven: '데이터 기반의 탁월함',
    dataDrivenDesc: '우리는 앞으로 나아갈 길을 밝히는 데이터의 힘을 믿습니다. 우리의 결정은 엄격한 분석과 측정 가능한 결과에 기반합니다',
    innovation: '혁신과 민첩성',
    innovationDesc: '급변하는 디지털 환경 속에서 우리는 변화를 수용하고, 새로운 접근 방식을 시도하며, 시장 트렌드에 신속하게 적응함으로써 앞서 나갑니다',
    integrity: '성실과 투명성',
    integrityDesc: '우리는 정직한 의사소통, 윤리적인 실천, 투명한 보고를 통해 신뢰를 구축합니다. 고객은 항상 자신의 상황을 명확히 알 수 있습니다',
    collaboration: '협력적인 파트너십',
    collaborationDesc: '우리는 고객과 함께 일합니다. 고객의 성공은 진정한 협력과 공동의 헌신을 통해 이루어집니다',
    improvement: '지속적인 개선',
    improvementDesc: '우리는 현상 유지에 결코 만족하지 않습니다. 우리는 끊임없이 방법을 개선하고, 지식을 확장하며, 지속적으로 서비스를 개선해 나갑니다',
    living: '우리의 가치관 실천',
    livingText: '이러한 가치관은 단순한 슬로건이 아닙니다. 이것은 우리 문화의 초석이며, 우리의 일상 업무를 안내하는 나침반입니다. TradFit 팀원 모두는 이러한 원칙을 구현하여, 고객이 탁월한 서비스뿐만 아니라 신뢰, 탁월함, 그리고 공동의 성공에 기반한 파트너십을 얻을 수 있도록 보장합니다.',
    workWithUs: '함께 일하기',
  },

  // Business Page
  business: {
    title: '사업 소개',
    subtitle: '사업 내용',
    marketingConsultingTitle: '마케팅 컨설팅',
    marketingConsultingDesc: '비즈니스 성장을 가속화하는 전략적 마케팅 계획 및 실행 지원',
    newBusinessTitle: '신규 사업 개발',
    newBusinessDesc: '신규 사업 런칭 및 확장을 위한 포괄적인 지원',
    crmConsultingTitle: 'CRM 컨설팅',
    crmConsultingDesc: '고객 관계 관리(CRM) 최적화 및 도입',
    hrConsultingTitle: 'HR 컨설팅',
    hrConsultingDesc: '인사 전략 및 인재 개발 솔루션',
    dataMarketingTitle: '데이터 마케팅',
    dataMarketingDesc: '마케팅 최적화를 위한 고급 데이터 분석 및 인사이트',
    adMarketingTitle: '광고 마케팅',
    adMarketingDesc: '포괄적인 광고 캠페인 관리 및 최적화',
    snsMediaMarketingTitle: 'SNS 및 미디어 마케팅',
    snsMediaMarketingDesc: '소셜 미디어 전략 및 콘텐츠 마케팅 솔루션',
    webCreationTitle: '웹 제작',
    webCreationDesc: '전문적인 웹사이트 디자인 및 개발 서비스',
    videoBrandingTitle: '영상 브랜딩',
    videoBrandingDesc: '영상 제작 및 브랜드 스토리텔링 서비스',
    systemDevelopmentTitle: '시스템 개발',
    systemDevelopmentDesc: '맞춤형 소프트웨어 및 시스템 개발 솔루션',
    learnMore: '자세히 보기',
    integratedApproach: '통합적 접근 방식',
    integratedText: '마케팅, 기술, 크리에이티브 분야의 전문 지식을 통합하여 귀하의 비즈니스 목표 달성을 지원합니다',
    discussProject: '프로젝트 상담',
    
    // Service 1: Hospitalia
    hospitaliaTitle: 'Hospitalia 음성 AI 솔루션',
    hospitaliaDesc: '일본 최초 Alexa SP 인증을 받은 음성 AI 플랫폼입니다. 관광·헬스케어·지자체를 위한 업계 특화형 솔루션을 제공합니다',
    hospitaliaDetail1Title: '업무 부하의 획기적인 감소',
    hospitaliaDetail1: 'Hospitalia는 문의 자동화, 다국어 지원, 업무 관리 간소화를 통해 현장의 업무 부하를 획기적으로 개선합니다. 직원은 객실 전화나 프론트 문의에 압도되지 않고 고객의 요청에 응대할 수 있습니다.',
    hospitaliaDetail2Title: '다양한 요구에 대응',
    hospitaliaDetail2: '숙박 시설의 게스트 경험 가치 향상, 의료 및 간호 현장의 효율적인 운영 지원 등 각 업계의 구체적인 요구에 맞춘 유연하고 효과적인 솔루션을 제공합니다. 고객의 과제에 밀착하여 최적의 솔루션을 제안함으로써 업무 효율화와 서비스 품질 향상을 지원합니다.',
    hospitaliaDetail3Title: '스마트 스피커를 허브로 한 새로운 경험 제안',
    hospitaliaDetail3: '스마트 스피커를 허브로 다양한 기기 및 서비스와 연동하여 더욱 편리하고 쾌적한 환경을 제공합니다. 예를 들어 숙박 시설에서는 게스트가 스마트 스피커를 통해 객실 조명 및 에어컨 제어, 프론트 문의, 룸서비스 주문 등을 음성으로 쉽게 수행할 수 있습니다. 의료 및 간호 현장에서는 간호사 호출 대응 감소에 음성 비서가 활용됩니다. 이를 통해 현장 업무 효율을 높이면서 사용자에게 직관적이고 사용하기 쉬운 경험을 제공합니다.',
    
    // Service 2: AI Consulting
    aiConsultingTitle: '생성형 AI 컨설팅 · 개발 지원',
    aiConsultingDesc: '최첨단 생성형 AI 기술을 활용하여 업무 효율화와 혁신 창출을 지원합니다. 전략 수립부터 구현까지 일관 지원합니다',
    aiConsultingDetail1Title: '배경과 필연성',
    aiConsultingDetail1: '생성형 AI의 활용은 앞으로의 기업 운영에 있어 생명선이라고도 할 수 있는 과제입니다. 생성형 AI를 활용할 수 있는 기업과 그렇지 못한 기업의 생산성은 가속도적으로 벌어질 것이라고 당사는 생각합니다. 생성형 AI의 활용 영역은 시스템 효율화에만 그치지 않고, 일반 업무·백오피스 업무·관리 업무 등 모든 업무의 생산성을 비약적으로 향상시키는 것이 가능합니다. 당사의 생성형 AI 개발·활용 노하우를 고객에게 제공함으로써, 일하는 분들의 워크라이프 밸런스 향상과 보다 안정적인 수익성 개선에 기여할 수 있다고 생각합니다.',
    aiConsultingPoint1: 'DX 추진',
    aiConsultingPoint1Desc: '기업 등의 다양한 업무를 생성형 AI로 효율화할 수 있습니다. 모든 측면에서 DX 추진이 가능합니다. 예를 들어, 영업 보조, 각종 문의, 광고·마케팅 등 DX화가 가능한 업무 범위는 다양합니다.',
    aiConsultingPoint2: '리스킬링을 통한 내재화 지원',
    aiConsultingPoint2Desc: '개인 단위로 생성형 AI의 활용 범위가 넓어짐으로써 조직 전체의 생산성이 비약적으로 높아집니다. 기업의 생성형 AI 활용 내재화를 당사가 동반 지원하여 더욱 업무 효율화가 가능합니다.',
    aiConsultingPoint3: '고속 신규 사업 개발',
    aiConsultingPoint3Desc: '생성형 AI를 올바르게 활용함으로써 신규 사업 개발을 비약적으로 빠르게 진행할 수 있습니다.',
    aiConsultingDetail2: '',
    aiConsultingDetail3: '',
    
    // Service 3: Website Creation
    websiteCreationTitle: '생성형 AI 웹사이트 제작 서비스',
    websiteCreationDesc: '생성형 AI의 힘으로 더 간단하고 소통이 잘 되는 웹사이트 구축',
    websiteCreationDetail1: '생성형 AI의 힘으로 웹사이트를 새롭게 바꿉니다.',
    websiteCreationDetail2: '고객의 요구 사항을 듣고 빠르면 2-3주 만에 홈페이지를 제작합니다. 방문자가 사용하기 쉬운 홈페이지를 구축하며, 현대 홈페이지에 필요한 보안과 표시 속도를 보장합니다.',
    websiteCreationDetail3: '기존 홈페이지 제작 서비스는 회사 정보, 문의 양식 등 기본 요소만 제공하는 경우가 많았습니다.',
    websiteCreationDetail4: '본 서비스에서는 EC 사이트 구축, CMS(콘텐츠 관리 시스템), 블로그 설치 등 다양한 요청에 대응할 수 있습니다.',
    websiteCreationDetail5: '또한 사이트 게시 후 유지 관리는 저희에게 맡겨주세요. 고객이 직접 유지 관리할 필요가 없습니다.',
    closeModal: '닫기',
    contactUs: '문의하기',
    mainServicesTitle: '핵심 서비스',
    mainServicesSubtitle: '최첨단 AI 기술과 깊은 업계 지식을 결합하여 고객의 비즈니스 과제에 최적화된 솔루션을 제공합니다',

    // Service 4: Cyber Security
    cyberSecurityTitle: '사이버 보안 서비스',
    cyberSecurityDesc: '20년 이상 인시던트 제로의 압도적인 실적입니다. AD 서버부터 모든 단말기까지 고객 요구에 맞는 유연한 도입을 실현합니다',
    cyberSecurityDetail1Title: '압도적인 실적',
    cyberSecurityDetail1: '당사가 제안하는 사이버 보안 제품은 20년 이상에 걸쳐 인시던트 제로라는 압도적인 실적을 자랑합니다',
    cyberSecurityDetail2Title: '일부 서버 및 단말기부터 도입 가능',
    cyberSecurityDetail2: '인증 기반인 AD(액티브 디렉토리) 서버만의 도입부터 전체 단말기 도입까지, 고객의 의향에 맞게 도입할 수 있습니다',
    cyberSecurityDetail3Title: '대기업 및 병원 등 다수의 고객이 이미 도입',
    cyberSecurityDetail3: '보안 요건이 엄격한 대기업 및 병원에 대한 도입이 증가하고 있습니다',

    // Service 5: AI Marketing
    aiMarketingTitle: '생성형 AI 마케팅 지원',
    aiMarketingDesc: '생성형 AI로 콘텐츠 제작을 혁신합니다. 데이터 기반 타겟팅과 최적화로 마케팅 ROI를 최대화하고 브랜드 가치를 향상시킵니다',
    aiMarketingDetail1Title: '생성형 AI를 통한 콘텐츠 제작 혁신',
    aiMarketingDetail1: '생성형 AI를 활용함으로써 고품질 마케팅 콘텐츠를 기존의 수배 속도로 제작할 수 있습니다. 블로그 기사, SNS 게시물, 광고 카피, 이메일 뉴스레터 등 모든 콘텐츠를 자동 생성·최적화하여 마케팅 활동의 생산성을 비약적으로 향상시킵니다.',
    aiMarketingDetail2Title: '데이터 기반 타겟팅과 최적화',
    aiMarketingDetail2: '생성형 AI와 머신러닝을 결합하여 고객 데이터를 심층 분석하고 최적의 타겟팅 전략을 수립합니다. 광고 배포 자동 최적화, 개인화된 메시지, 실시간 A/B 테스트를 통해 마케팅 ROI를 최대화합니다.',
    aiMarketingDetail3Title: '브랜드 강화와 고객 참여도 향상',
    aiMarketingDetail3: '생성형 AI를 활용한 브랜드 스토리텔링을 통해 고객과의 깊은 관계를 구축합니다. SNS 마케팅, 인플루언서 연계, 커뮤니티 형성 등 다각적인 접근 방식으로 고객 참여도를 높이고 장기적인 브랜드 가치를 향상시킵니다.',
  },

  // Stats Page
  // Works Page
  works: {
    heroTitle: '제작 실적 — Works',
    description: 'TradFit이 생성형 AI로 제작한 공개 중인 웹사이트를 소개합니다',
    siteLink: '사이트 보기',
    comingSoon: '준비 중',
    items: [
      { name: '에이오랜드 주식회사', desc: '이바라키현 미토시의 부동산 매매·투자 컨설팅' },
      { name: '이와사키 공업 주식회사 ROOFIX', desc: '초경량 태양광 패널과 폴리우레아 방수의 일체 공법' },
      { name: 'TBM 건강미용연구소 주식회사', desc: '군마현 다카사키시의 건강·미용 종합연구소' },
      { name: '멘야 카토효타로 상점', desc: '오다와라 명물·최고급 미소라멘 전문점' },
      { name: 'Hotel Bireiz', desc: '군마현 마에바시시의 레저 호텔' },
      { name: 'JEANA HARBOR 세키네 케이스케', desc: '정수리·두피 고민 전문 살롱' },
      { name: '호무라 커피', desc: '세타가야·다이자와의 자가배전 커피 전문점' },
      { name: '루비라 주식회사', desc: 'AI로 기업 성장을 막는 정체를 개선' },
      { name: 'YUSUKE GOTO Official Site', desc: '두피·미발 개선 어드바이저' },
      { name: '인연맺기 와하하', desc: '' },
    ],
  },

  // Stats Page
  stats: {
    title: '실적',
    description: '업종, 업태, 규모에 관계없이 생성형 AI의 힘으로 고객의 성장을 지원합니다',
    clientCategoriesTitle: '거래처 (일부 발췌)',
    clientCategories: ['미용', '에스테틱', '브라이달', '보석', '개인 사업자', 'IT', '통신', '금융', '메가뱅크', '지방은행', '신용금고', '신탁은행', '생명보험', '손해보험', '리스', '건설', '종합 건설', '부동산', '디벨로퍼', '철도', '상업 시설', '레지던스', '시공 관리', '도장', '제약', '병원', '클리닉', '간호', '호텔', '료칸', '민박', '음식', '청소', '제조업', '소매', '어패럴', '도매', '배송', '창고', '사사직', '회계 사무소', '컨설팅', '인재 소개', '학교 법인', 'NPO 법인'],
  },

  // News Page
  news: {
    title: '뉴스',
    subtitle: 'NEWS',
    noArticles: '기사가 없습니다',
    backToList: '목록으로 돌아가기',
    articleNotFound: '기사를 찾을 수 없습니다',
    articleNotFoundDesc: '찾으시는 기사가 삭제되었거나 URL이 잘못되었을 수 있습니다.',
    previousArticle: '이전 기사',
    nextArticle: '다음 기사',
    relatedArticles: '관련 기사',
    noContent: '본문이 없습니다.',
    share: '공유',
    viewOriginal: '원문 기사 보기',
    pressRelease: '보도자료',
    companyNews: '회사 소식',
    event: '이벤트',
    award: '수상',
    item1: 'TradFit, 주요 기술 기업과 새로운 전략적 파트너십 발표',
    item2: '연말 실적: 마케팅 컨설팅 서비스 사상 최대 성장 기록',
    item3: 'TradFit, 2025 연례 마케팅 서밋 개최 예정',
    item4: '도쿄 신규 오피스 오픈',
    item5: 'TradFit, 데이터 분석 팀 확대',
    item6: '올해의 톱 마케팅 컨설팅 기업으로 선정',
    item7: '새로운 CRM 컨설팅 서비스 라인 출시',
    item8: 'TradFit 창립 5주년 기념',
  },

  // SEO
  seo: {
    homeTitle: '도쿄 생성형 AI 및 음성 AI 및 사이버 보안 TradFit 주식회사 | AI 솔루션',
    homeDescription: 'TradFit 주식회사는 도쿄를 거점으로 하는 생성형 AI 및 음성 AI의 리딩 기업입니다. Hospitalia 음성 AI 솔루션, 생성형 AI 컨설팅 및 개발 지원, 사이버 보안 서비스, 생성형 AI 마케팅 지원 서비스를 제공합니다. 비즈니스 DX 추진을 지원합니다.',
    homeKeywords: '생성형 AI, 음성 AI, AI 컨설팅, 사이버 보안, 생성형 AI 마케팅, DX 추진, 도쿄',
    aboutTitle: '도쿄 회사 개요 TradFit 주식회사 | 생성형 AI 및 음성 AI 기업 정보',
    aboutDescription: 'TradFit 주식회사의 회사 개요. 도쿄 치요다구에 본사를 둔 생성형 AI 및 음성 AI의 리딩 기업. 기업 이념, 비전, 회사 정보를 소개합니다.',
    aboutKeywords: '회사 개요, TradFit, 생성형 AI 기업, 음성 AI 기업, 도쿄, 치요다구',
    businessTitle: '도쿄 사업 소개 TradFit 주식회사 | 음성 AI, 생성형 AI, 사이버 보안, 마케팅',
    businessDescription: 'TradFit 주식회사의 사업 소개. Hospitalia 음성 AI 솔루션, 생성형 AI 컨설팅 및 개발 지원, 사이버 보안 서비스, 생성형 AI 마케팅 지원 서비스의 4대 핵심 서비스를 제공합니다.',
    businessKeywords: '사업 소개, 생성형 AI 컨설팅, 음성 AI, Hospitalia, 사이버 보안, 생성형 AI 마케팅, DX 추진, 도쿄',
    newsTitle: '도쿄 뉴스 TradFit 주식회사 | 생성형 AI 및 음성 AI 최신 정보',
    newsDescription: 'TradFit 주식회사의 뉴스 및 보도자료 목록. 최신 정보, 보도자료, 이벤트 정보를 전해드립니다.',
    newsKeywords: '뉴스, 보도자료, 생성형 AI, 음성 AI, 도쿄',
    contactTitle: '도쿄 문의하기 TradFit 주식회사 | 생성형 AI 및 음성 AI 상담',
    contactDescription: 'TradFit 주식회사 문의 페이지. AI 솔루션 도입 상담을 접수합니다.',
    contactKeywords: '문의하기, 상담, 생성형 AI 상담, 도쿄',
    statsTitle: '도쿄 실적 및 수치 TradFit 주식회사 | 생성형 AI 및 음성 AI 기업 실적',
    statsDescription: 'TradFit 주식회사의 실적 및 수치. 생성형 AI 및 음성 AI 분야의 풍부한 도입 실적과 기업의 DX 추진 지원 성과를 소개합니다.',
    statsKeywords: '실적, 수치, 도입 실적, 생성형 AI, 음성 AI, 도쿄',
    worksTitle: '제작 실적 | TradFit 주식회사',
    worksDescription: 'TradFit이 생성형 AI로 제작한 공개 웹사이트 목록. 부동산, 음식, 미용, 호텔 등 다양한 업종의 실적을 확인하실 수 있습니다.',
    worksKeywords: '제작 실적, 웹 제작, 생성형 AI, 홈페이지 제작, TradFit',
    valuesTitle: '기업 이념 | TradFit 주식회사',
    valuesDescription: 'TradFit 주식회사의 기업 이념. 고객 최우선, 데이터 기반, 혁신, 성실, 협력, 지속적인 개선의 6가지 핵심 가치를 소개합니다.',
    valuesKeywords: '기업 이념, 가치관, 미션, TradFit',
    recruitmentTitle: '채용 정보 | TradFit 주식회사',
    recruitmentDescription: 'TradFit 주식회사의 채용 정보. 생성형 AI 및 음성 AI의 리딩 기업에서 당신의 커리어를 다음 단계로.',
    recruitmentKeywords: '채용, 구인, 커리어, AI 기업, 도쿄',
    privacyTitle: '개인정보 보호정책 | TradFit 주식회사',
    privacyDescription: 'TradFit 주식회사의 개인정보 보호정책. 개인정보 취급에 관한 방침을 정하고 있습니다.',
    privacyKeywords: '개인정보 보호정책, 개인정보 보호, TradFit',
    securityTitle: '정보 보안 | TradFit 주식회사',
    securityDescription: 'TradFit 주식회사의 정보 보안 방침. 고객 데이터 보호 및 보안 대책에 대해 소개합니다.',
    securityKeywords: '정보 보안, 데이터 보호, 보안 정책, TradFit',
    servicePageTitle: '제공 서비스',
    servicePageProcess: '진행 방법',
    servicePageBenefits: '도입 효과',
    servicePageCtaPrefix: '에 대해',
    servicePageCtaHighlight: '무료 상담으로 시작하기',
    servicePageCtaDesc: '귀사의 과제와 요구 사항을 말씀해 주세요. TradFit 전문가가 최적의 솔루션을 제안합니다',
  },

  // Contact Page
  contact: {
    title: '문의하기',
    subtitle: '언제든지 문의해 주세요',
    sendMessage: '메시지 보내기',
    name: '이름',
    email: '이메일 주소',
    company: '회사명',
    phone: '전화번호',
    subject: '제목',
    message: '메시지 내용',
    send: '메시지 보내기',
    sending: '전송 중...',
    successMessage: '메시지를 보내주셔서 감사합니다. 곧 연락드리겠습니다!',
    errorMessage: '메시지 전송 중 오류가 발생했습니다. 다시 시도해 주세요.',
    selectSubject: '제목을 선택해 주세요',
    generalInquiry: '일반 문의',
    marketingConsulting: '마케팅 컨설팅',
    dataAnalytics: '데이터 분석',
    webDevelopment: '웹 개발',
    partnership: '파트너십 기회',
    career: '채용 문의',
    other: '기타',
    contactInfo: '연락처 정보',
    address: '주소',
    addressText: 'TradFit 주식회사\n100-0005 도쿄도 치요다구 마루노우치 1-6-5\n마루노우치 키타구치 빌딩 9F',
    businessHours: '영업 시간',
    businessHoursText: '월요일 - 금요일: 오전 9:00 - 오후 6:00 (JST)\n토요일, 일요일, 공휴일: 휴무',
    followUs: '팔로우하기',
    characters: '자',
  },

  articles: [
    {
      date: '2026.01.07',
      category: '도입 사례 / 발표',
      title: '전 노무라 증권 전무 이사, 전 노무라 종합연구소 부회장 모모세 히로노리 씨가 TradFit 사의 에그제큐티브 어드바이저로 취임',
      content: `<p><strong>생성형 AI·음성 AI·IoT·로봇공학·생체 인증 등의 기술을 활용하여 각종 업계의 인력 부족 해소 사업 「Hospitalia」를 중심으로 생성형 AI 컨설팅 사업 및 생성형 AI 개발 사업 등 복수의 서비스를 제공하는 TradFit(트래드핏) 주식회사(본사: 도쿄도 치요다구, 대표이사: 토다 요시키, 이하 「TradFit」)는, 더욱 경영 체제 강화 및 사업 확대 향상 등을 목적으로 모모세 히로노리 씨를 에그제큐티브 어드바이저로 취임한 것을 알려드립니다.</strong></p>

      <figure class="wp-block-image">
        <img src="https://prcdn.freetls.fastly.net/release_image/33116/187/33116-187-06be5066e3e4bc5b597aab5ac155500c-3900x2601.jpg?width=1950&height=1350&quality=85%2C65&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6">
      </figure>

      <h3><strong>■ 배경·과제</strong></h3>
      <p>관광·호텔·료칸·병원·부동산·간병 시설·전국 각지의 지역 사업자·행정 자치체는 최근 인력 부족 등의 큰 과제에 직면하고 있습니다.</p>

      <p>위의 업계 및 부수하는 관련 업계에서 가속화되는 DX(디지털 전환), 그 중에서도 AI 분야에 대한 기대는 높으며, TradFit은 클라이언트 및 협업(공동 창조) 파트너 기업 등과 함께 모든 측면에서 공동 창조, 변혁을 지속하며, 삼방요시(三方よし)로 일본의 각 업계 등이 안고 있는 큰 과제를 해결해 나갑니다.</p>

      <p>TradFit은 관광·호텔·료칸·부동산·병원·간병 시설·전국 각지의 지역 사업자·행정 자치체 등에 특화한 AI 및 소프트웨어 등을 개발, 운영하고 있습니다.</p>

      <p>TradFit의 강점은 각 업계의 클라이언트 및 국내외 기업 등과 파트너십을 구축하여, 1개사에서는 해결할 수 없는 다양한 과제를 공동 창조하면서 해결하고, 비즈니스를 가속화하는 수비와 공격의 지식재산 전략 수립 및 지식재산 취득, 국내·해외 전개를 위한 특허 포트폴리오 구축을 가속화하고 있는 것입니다.</p>

      <p>이번에 일본을 포함한 국제 시장, 각 업계 및 산업에서 복잡한 과제에 맞서 온 리더인 모모세 히로노리 씨를 에그제큐티브 어드바이저로 맞이함으로써, 더욱 경영 체제 강화, 사업 확대 향상 등을 추진합니다.</p>

      <h3><strong>■ TradFit 에그제큐티브 어드바이저 모모세 히로노리 코멘트</strong></h3>
      <p>이번에 TradFit의 에그제큐티브 어드바이저로 취임하게 된 모모세입니다. 전직의 인연으로 토다 사장을 소개받아, 특히 일본의 사회 과제를 삼방요시(三方よし)로 해결해 나가겠다는 생각에 강하게 공감했습니다.</p>

      <p>모든 업계 및 산업 과제에 대해, 삼방요시(三方よし)로 국내외 기업과의 파트너십을 소중히 하며, 1개사에서는 해결할 수 없는 다양한 과제를 각사와 연계하면서 해결을 시도하고, 더 나은 사회를 실현해 나가겠다는 생각에 큰 가능성과 사회적 의의를 느꼈습니다.</p>

      <p>저 자신은 금융이라는 세계에 오랫동안 몸을 담아, 다양한 산업 및 기업의 발전에 기여하고, 더 나은 사회의 실현에 힘을 쏟아 왔습니다.</p>

      <p>쌓아 올린 인연과 네트워크, 금융 및 산업에 관한 지견, 기업 경영자로서의 커리어를 바탕으로, TradFit 사가 안고 있는 이념을 실현하고, TradFit 사가 앞으로 비약적으로 발전하는 데 전력으로 지원할 각오입니다.</p>

      <h3><strong>■ TradFit 에그제큐티브 어드바이저 모모세 히로노리 약력</strong></h3>
      <p>1985년 오사카 대학 경제학부 졸업 후, 노무라 증권 주식회사 입사.<br>
      2008년 동사 임원 오사카 지점장.<br>
      2013년 동사 상무 오사카 주재 겸 오사카 지점장.<br>
      2017년 동사 전무 오사카 주재.<br>
      2019년 주식회사 노무라 종합연구소 이사 부회장.<br>
      2025년 TradFit 주식회사 에그제큐티브 어드바이저 취임.</p>

      <h3><strong>■ TradFit 대표이사 토다 요시키 코멘트</strong></h3>
      <p>이번에 일본의 각 업계가 안고 있는 큰 과제 해결의 실현을 위한 더욱 경영 체제 강화 및 사업 확대 향상 등을 목적으로 모모세 씨에게 TradFit의 에그제큐티브 어드바이저로 취임해 주셨습니다.</p>

      <p>모모세 씨는 노무라 그룹에서 노무라 증권 전무 오사카 주재, 노무라 종합연구소 부회장을 거쳐, 현재는 세계적인 대형 유명 PE 펀드의 공동 회장을 맡고 계십니다.</p>

      <p>노무라 증권에서는 오사카, 도쿄에서 27년간 투자 은행 업무에 종사하며, 수많은 일본 기업의 M&A, 투자, 자금 조달 사건을 담당한 경험과 실적을 보유하고 계십니다.</p>

      <p>TradFit의 경영 체제 강화 및 사업 확대 향상 등, 사업 추진에 있어, 경영 리더로서 폭넓은 산업 및 업계에서의 실적, 경험, 네트워크를 구축하고 계신 모모세 씨로부터 많은 것을 배우고, 앞으로의 TradFit의 비약적인 성장에 도전해 나갈 각오입니다.</p>

      <h3><strong>■ TradFit의 전개하는 서비스에 대해</strong></h3>
      <p>TradFit은 「생성형 AI·음성 AI·IoT·로봇공학·생체 인증 기술 등을 활용한 관광·호텔·료칸·부동산·병원·간병 시설·전국 각지의 지역 사업자·행정 자치체 등의 수익성 개선 등의 서비스 플랫폼」 사업을 전개하고 있습니다. 인력 부족 문제 등의 큰 사회 과제의 해결을 추진하며, 서비스를 제공하고 있습니다.</p>

      <p>자율 주행 로봇공학과의 시스템 연동 등을 완료하여, 각 업계의 클라이언트 및 국내외 협업(공동 창조) 파트너 기업 등과 함께 다양한 과제를 해결하고, 비즈니스를 가속화하는 수비와 공격의 지식재산 전략 수립 및 지식재산 취득, 국내·해외 전개를 위한 특허 포트폴리오 구축을 가속화하고 있습니다.</p>

      <p>TradFit의 서비스 플랫폼을 통해 사업자는, 업무의 효율화 및 인력 부족을 보완하는 서비스에 의해, 비용 절감 및 매출 증가를 가능하게 하며, 더욱 국내외의 협업(공동 창조) 파트너와 오픈 이노베이션을 추진하고 있기 때문에, 새로운 비즈니스 전개 가능성이 있습니다.</p>

      <p>TradFit은 국내외 협업(공동 창조) 파트너 기업과 함께 앞으로도 일본과 세계의 기업 등이 매일 직면하고 있는 사회 과제를 해결하고, 지속 가능한 미래를 이끌기 위해, 새로운 사회 인프라를 목표로 하겠습니다.</p>

      <h3><strong>■ TradFit 소개</strong></h3>
      <p>【회사명】TradFit(트래드핏) 주식회사<br>
      【소재지】도쿄도 치요다구 마루노우치 1-6-5 마루노우치 키타구치 빌딩 9F<br>
      【대표자】대표이사 토다 요시키<br>
      【설립】2017년 8월<br>
      【자본금】1억 엔<br>
      【웹사이트】<a target="_blank" rel="nofollow ugc noopener" href="https://company.tradfit.com">https://company.tradfit.com</a></p>

      <h3><strong>■ 본 건에 관한 문의</strong></h3>
      <p>TradFit 주식회사<br>
      E-mail:info@tradift.com</p>

      <p><strong>■ 본 건에 관한 보도 관계자 문의</strong><br>
      E-mail:contact@tradfit.com</p>

      <p><strong>■ 기사 링크（PRTIMES）</strong><br>
      <a target="_blank" rel="nofollow ugc noopener" href="https://prtimes.jp/main/html/rd/p/000000187.000033116.html">https://prtimes.jp/main/html/rd/p/000000187.000033116.html</a></p>
      `
    },
    {
      date: '2025.12.02',
      category: '도입 사례 / 발표',
      title: '트래블 보이스 게재. TradFit, NEC 네트웍스 & 시스템 통합과 대리점 계약 체결, AI 음성 서비스 "Hospitalia" 지원 체제 강화',
      content: `<p>숙박 시설을 위한 디지털 솔루션을 제공하는 TradFit 주식회사는 호텔 업계용 AI 음성 서비스 "Hospitalia"와 관련하여 NEC 네트웍스 & 시스템 통합 주식회사와 대리점 계약을 진행하고 있습니다. 이를 통해 일본 전역의 호텔에 대한 판매 및 지원 체제가 강화될 것입니다.</p>
  <img loading="lazy" width="800" height="288" src="https://company.tradfit.com/wp-content/uploads/2025/12/thumb_w800_a125cc1c-13b3-4248-bb70-2ac09dff0d5f.jpeg" alt="" class="w-full h-auto rounded-lg my-6" />
  <p>TradFit은 일본 최초로 Amazon으로부터 "Alexa Smart Properties for Hospitality" 솔루션 제공업체로 인증받았으며, Amazon AI를 결합한 호텔 업계용 "Hospitalia"를 개발 및 배포하고 있습니다.</p>
  <p>Hospitalia는 Amazon의 AI 비서 Alexa를 기반으로 한 호텔 업계용 서비스로, 스마트 디스플레이의 음성, 텍스트, 이미지 및 비디오를 통해 사용자를 지원합니다.</p>
  <p><strong>■ 링크</strong><br><a href="https://www.travelvoice.jp/20251202-158844" target="_blank" rel="noreferrer noopener">https://www.travelvoice.jp/20251202-158844</a></p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>
  <p><strong>■ 본 건에 대한 언론 문의</strong><br>E-mail:contact@tradfit.com</p>`
    },
    {
      date: '2025.11.27',
      category: '도입 사례 / 발표',
      title: 'TradFit 전국 판매 및 지원 체제 강화. 비즈니스 파트너(*)와 함께 Amazon Echo 기업용 호텔 객실 서비스 "Hospitalia" 전국 확대',
      content: `<p><span style="color: #546e7a;">~각 비즈니스 파트너(*)와 함께 호텔 업계의 AI 활용 및 DX 가속화를 강력히 지원~</span></p>
  <p><strong>TradFit 주식회사(본사: 도쿄도 치요다구, 이하 "TradFit")는 당사가 제공하는 호텔 업계용 서비스 "Hospitalia"의 판매와 관련하여, NEC 네트웍스 & 시스템 통합 주식회사(*)(본사: 도쿄도 미나토구, 이하 "NEC 네트웍스 & 시스템 통합")와 대리점 계약을 진행하고 있습니다.</strong></p>
  <p><strong>이번 계약을 통해 "Hospitalia"는 그 어느 때보다 광범위한 판매 및 지원 체제를 일본 전역의 호텔에 제공할 수 있게 되었습니다.</strong></p>
  <p><strong>호텔 업계, 특히 AI 분야에서 가속화되는 DX(디지털 전환)에 대한 기대가 높으며, 우리는 고객과 함께 개혁하여 새로운 시대를 구축하는 좋은 파트너가 되는 것을 목표로 합니다.</strong></p>
  <p><strong>■ 본 제품 "Hospitalia"의 특징</strong><br>TradFit은 일본에서 유일하게 Amazon으로부터 Alexa Smart Properties for Hospitality의 솔루션 제공업체로 인증받은 스타트업으로, Amazon AI를 결합한 호텔 업계용 "Hospitalia" 서비스를 협력하여 개발 및 배포하고 있습니다.</p>
  <img src="https://prcdn.freetls.fastly.net/release_image/33116/186/33116-186-e9cb6a13abe1491540e01c87160e82ff-850x446.jpg?width=1950&height=1350&quality=85&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6" />
  <p>우리는 "생성형 AI, 음성 AI, IoT 및 로봇 공학 등의 기술을 활용하여 호텔 업계의 수익성 향상을 지원하는 서비스 플랫폼 비즈니스"를 운영하고 있습니다. 주로 호텔 업계의 인력 부족과 같은 주요 사회적 문제를 해결하고 서비스를 제공하는 데 중점을 둡니다.</p>
  <p><strong>■ TradFit의 강점과 특징</strong><br>TradFit은 호텔 업계가 직면한 문제를 해결할 수 있는 특허 포트폴리오를 보유하고 있으며, 호텔 업계의 업무 스타일에 맞춤화된 서비스를 제공한다는 강점이 있습니다.</p>
  <p>서비스 플랫폼을 통해 TradFit은 국내외 숙박객의 경험 가치 향상, 다양한 문의 및 주문 처리(다국어 지원), 호텔 직원의 업무 부하 감소, 인력 부족 보완을 위한 서비스를 호텔 업계에 제공합니다.</p>
  <p><strong>■ TradFit 소개</strong><br>【회사명】TradFit 주식회사<br>【소재지】도쿄도 치요다구 마루노우치 1-6-5 마루노우치 키타구치 빌딩 9F<br>【대표자】대표이사 토다 요시키<br>【설립】2017년 8월<br>【자본금】1억 엔<br>【서비스 웹사이트】<a href="https://hospitalia.jp/" target="_blank" rel="noreferrer noopener">https://hospitalia.jp</a><br>【기업 웹사이트】<a href="https://company.tradfit.com/" target="_blank" rel="noreferrer noopener">https://company.tradfit.com/</a></p>
  <img src="https://prcdn.freetls.fastly.net/release_image/33116/186/33116-186-e659118fc5c31b18ebeff2c7ce8768ab-850x306.jpg?width=1950&height=1350&quality=85&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6" />
  <p><strong>■ 링크</strong><br><a href="https://prtimes.jp/main/html/rd/p/000000186.000033116.html" target="_blank" rel="noreferrer noopener">https://prtimes.jp/main/html/rd/p/000000186.000033116.html</a></p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>
  <p><strong>■ 본 건에 대한 언론 문의</strong><br>E-mail:contact@tradfit.com</p>`
    },
    {
      date: '2025.11.21',
      category: '도입 사례 / 발표',
      title: 'Alexa Smart Properties를 통한 관광, 숙박, 의료 산업 및 지자체의 업무 효율화 및 생산성 향상 지원 - 증가하는 인바운드 관광 및 인구 감소로 인한 인력 부족 및 다국어 지원 문제 해결에 기여',
      content: `<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_main.jpg" alt="TradFit 주식회사 대표이사 토다 요시키" class="w-full h-auto rounded-lg my-6" />
      <h5><strong>Alexa Smart Properties 활용 서비스 특징</strong></h5>
<ul>
<li>숙박 시설의 음성 기반 주문 접수를 통해 프론트 데스크 수신 전화 절반으로 감소</li>
<li>다국어 지원을 통해 숙박객에게 원활하게 응대하여 인바운드 수요에 기여</li>
<li>강력한 보안을 통해 불특정 다수가 사용하는 환경에서도 안전하게 운영</li>
</ul>

<p><strong>회사명:</strong> TradFit 주식회사</p>
<p><strong>업종:</strong> 클라우드 AI를 활용한 음성 데이터 플랫폼 구축 및 운영</p>
<p><strong>설립:</strong> 2017년 8월</p>
<p><strong>소재지:</strong> 100-0005 도쿄도 치요다구 마루노우치 1-6-5 마루노우치 키타구치 빌딩 9F</p>
<p><strong>웹사이트:</strong> <a href="https://company.tradfit.com/" target="_blank">https://company.tradfit.com/</a></p>

<p><a href="https://ds6yc8t7pnx74.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/pdf/AmazonAlexa_SP_TradFit.pdf" target="_blank" class="inline-block px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors">PDF 버전 다운로드</a></p>

<h3><strong>"Hospitalia" - 숙박 시설, 의료/간호 현장 및 지자체 문제 해결의 열쇠</strong></h3>

<p>TradFit은 음성, 생성형 AI, 로봇 공학 및 IoT 기술을 활용하여 관광, 숙박, 의료 산업 및 지자체에서 전 세계 사람들에게 더 나은 삶을 실현하는 서비스를 제공함으로써 사회적 문제를 해결하는 것을 목표로 합니다. TradFit의 음성 AI 솔루션은 업무 효율성뿐만 아니라 사회적 문제 해결에도 기여합니다. TradFit은 Amazon Alexa를 기반으로 숙박 시설, 의료 및 간호, 지자체를 포함한 접객 산업을 위한 "Hospitalia"라는 서비스를 개발합니다. 음성, 스마트 디스플레이의 텍스트, 이미지 및 비디오를 통해 고객 경험 개선 및 직원 업무를 지원합니다.</p>

<p>대표이사 토다 요시키는 다음과 같이 강조합니다. "TradFit은 창립 이래 지식재산 전략에 집중해 왔습니다. 우리의 큰 강점은 지식재산을 활용한 '삼방요시(三方よし)'(모두에게 이로운) 비즈니스 개발입니다. 우리는 관광 및 숙박 산업뿐만 아니라 의료 및 지자체에서도 매출 향상과 비용 절감으로 직결되는 다수의 비즈니스 모델 특허와 기본 특허를 보유하고 있습니다. 우리는 이러한 지식재산 전략을 통해 우리 자신을 철저히 차별화합니다. 그 위에 일본이 직면한 사회적 문제 해결, 각 산업 고객 문제 해결, 그리고 우리 자신의 성장을 아우르는 삼방요시를 고객 및 파트너와 함께 추진합니다."</p>

<p>이사 겸 CTO 이토 토모하루는 Alexa 개발자 커뮤니티에서 특히 활동적이고 공헌하는 개발자 및 엔지니어를 인정하는 Alexa Champion으로 선정되었으며, 다음과 같이 강조합니다. "TradFit은 대화 경험을 개선하기 위해 기술 개발에 지속적으로 노력해 왔습니다. TradFit의 또 다른 큰 강점은 이전에는 얻을 수 없었던 고유한 데이터를 확보하고 대화 노하우와 업태별로 다른 숙박 시설의 특성을 결합하여 다양한 패턴에 맞는 대화를 설계할 수 있다는 것입니다. 또한 생성형 AI 기술을 사용하여 음성 인식 정확도를 향상시키는 데 계속 집중하고 있습니다."</p>

<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_003.jpg" alt="TradFit Co., Ltd. Director CTO Tomoharu Ito" class="w-full h-auto rounded-lg my-6" />
<p class="text-sm text-gray-600">TradFit 주식회사 이사 CTO 이토 토모하루</p>

<h3><strong>음성과 생성형 AI를 활용하여 숙박업이 직면한 문제 해결</strong></h3>

<p>최근 숙박업계는 다양한 문제에 직면해 있습니다. 숙박업은 직원에게 높은 수준의 고객 서비스 기술을 요구하며, 하루 24시간 고객의 요구에 응대해야 합니다. 또한, 인바운드 수요가 확대됨에 따라 해외 고객을 맞이하기 위한 다국어 지원이 필수 되었습니다. 이러한 배경에서 업무량은 증가하고 만성적인 인력 부족도 문제가 되었습니다. 인건비 또한 상승 추세에 있으며, 수익성을 높이는 운영 효율화가 시급한 과제가 되었습니다.</p>

<p>"숙박업은 인바운드 관광 증가로 인한 인력 부족 및 다국어 지원 등 많은 문제에 직면해 있습니다. TradFit이 생성형 AI와 음성 AI를 결합한 비즈니스용 Alexa를 개발했을 때, '어느 산업이 우리의 서비스를 통해 사회와 산업이 직면한 문제를 해결하는 데 가장 크게 기여할 수 있을까'를 고민했고, 산업 현장을 방문하여 국내외 여행객들과 생생한 인터뷰를 진행했습니다. 시행착오 끝에 우리는 먼저 숙박업에 집중하기로 결정했습니다. 그 이후로 우리는 숙박업이 직면한 문제를 해결하기 위해 Hospitalia 브랜드로 음성 × AI 솔루션을 제공해 왔습니다." (토다)</p>

<h3><strong>Alexa Smart Properties를 통해 인바운드 관광에 대응하고 프론트 데스크 수신 전화를 절반으로 감소</strong></h3>

<p>Alexa Smart Properties는 숙박 시설, 노인 요양 시설 및 지자체에 맞춤화된 서비스로, 2023년 12월부터 일본에서 출시되었습니다. TradFit은 Amazon과 Alexa Smart Properties for Hospitality의 솔루션 제공업체 계약을 체결하여 홈 화면과 알림 기능을 커스터마이징하고 고유한 맞춤형 스킬을 구축하여 숙박 시설의 요구를 더 잘 충족하는 서비스를 제공합니다.</p>

<p>Alexa Smart Properties의 주요 장점 중 하나는 강력한 보안 덕분에 불특정 다수가 사용하는 환경에서도 안전하게 운영할 수 있다는 것입니다. 이토는 "Alexa Smart Properties를 사용하면 사용자의 음성 기록과 음성 활동이 보호되고 개인 정보 보호와 보안이 모두 실현되어 안심하고 사용할 수 있는 환경이 조성됩니다."라고 말합니다.</p>

<p>오다큐 호텔 센추리 서던 타워에서는 375개 전 객실에 Alexa Smart Properties 호환 Echo Show를 설치했습니다. 인바운드 수요에 대응하는 다국어 지원을 실현함과 동시에 비품 대여 등 고객 주문의 음성 접수도 실현했습니다. Alexa에 대한 하루 평균 약 30건의 문의 중 전화 통화로 전환된 것은 10건에 불과했습니다(*1). 류구조 스파 호텔 미카즈키에서는 479개 전 객실에 Alexa Smart Properties를 설치했습니다. Alexa Smart Properties 호환 Echo Show를 사용하여 호텔 내 시설 및 이벤트 안내를 제공하는 것 외에도 음성 기능을 더욱 강화하여 프론트 데스크 수신 전화 비율을 48%에서 20%로 낮췄습니다(*2).</p>

<h3><strong>Alexa Smart Properties를 기반으로 서비스 확장 및 추가적인 생성형 AI 활용 전망</strong></h3>

<p>앞으로 TradFit은 Alexa Smart Properties를 활용한 서비스를 더욱 확장할 것입니다.</p>

<p>이토는 열정을 표현했습니다. "앞으로 우리는 Alexa Smart Properties를 통해 숙박업, 의료업 및 지자체를 포함한 다양한 기업과 조직에 TradFit이 커스터마이징한 고부가가치 서비스를 제공하고 싶습니다. 이 이니셔티브를 통해 우리는日本 호텔 업계의 문제 해결에 기여하고 사회적 문제 해결에 기여할 것입니다."</p>

<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_002.JPG" alt="TradFit Co., Ltd. Representative Director Yoshiki Toda" class="w-full h-auto rounded-lg my-6" />
<p class="text-sm text-gray-600">TradFit 주식회사 대표이사 토다 요시키<br>촬영 장소: WeWork 마루노우치 키타구치</p>

<p>향후 사업 확장과 함께 TradFit은 모두가 건강하게 살 수 있는 '웰빙(well-being)' 사회를 실현하는 것을 목표로 합니다. "일본에 기반을 두면서 우리는 저출산 고령화, 인구 감소, 1인 가구 등 많은 문제를 해결하기 위해 숙박업, 의료업, 지자체 등 다양한 방향으로 사업을 전개할 것입니다. 또한 현황과 미래 전망을 고려할 때, 문제 선진국이라고 불리는 일본 사회가 직면한 문제들이 전 세계적으로도 발생할 것이라고 생각합니다. 우리는 일본에서 시작된 서비스가 전 세계적으로 유용할 것이라고 믿으며, 앞으로 해외로 서비스를 확장하여 품요로운 삶을 제공할 것입니다."라고 토다 대표는 열정을 표했습니다.</p>

<h5><strong>SP 프로필</strong></h5>

<p>우리의 미션은 "당사가 제공하는 서비스를 통해 전 세계 사람들에게 더 나은 삶을 제공하는 것"이며, 음성 AI 솔루션을 개발합니다. 최근 에는 Alexa 기업 서비스 "Alexa Smart Properties"를 기반으로 자체 기술을 추가하여 일본 호텔 업계 및 지자체에 맞게 현지화한 서비스 "Hospitalia"를 제공하며 실적을 쌓고 있습니다.</p>

<p class="text-sm text-gray-600">*1 데이터 수집 기간: 2025년 2월. Alexa 응답 중 전화 통화로 연결된 횟수를 계산하여 프론트 데스크 문의 감소 효과 측정.</p>
<p class="text-sm text-gray-600">*2 수신 전화율: 일일 숙박 그룹 수 ÷ 프론트 데스크 수신 전화 수 = 수신 전화율. 여기서는 측정 기간 동안의 평균 수신 전화율을 설명합니다.<br>설치 전 측정 기간: 2023년 12월 3일 ~ 2023년 12월 17일.<br>설치 후 측정 기간: 2024년 1월 16일 ~ 2024년 2월 15일.</p>

<p class="text-sm text-gray-600 mt-4">*인터뷰 기간: 2025년 5월</p>
<p class="text-sm text-gray-600">*모든 설명(직위, 숫자, 고유 명사 등)은 인터뷰 당시의 정보입니다.</p>

<p class="mt-6"><strong>■ 원본 기사 링크</strong><br><a href="https://developer.amazon.com/ja-JP/blogs/alexa/alexa-smart-properties/tradfit" target="_blank" rel="noreferrer noopener">https://developer.amazon.com/ja-JP/blogs/alexa/alexa-smart-properties/tradfit</a></p>

<p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>

<p><strong>■ 본 건에 대한 언론 문의</strong><br>E-mail:contact@tradfit.com</p>`
    },
    {
      date: '2025.07.28',
      category: '도입 사례 / 발표',
      title: '취득 특허, 트래블 보이스 게재. TradFit, 다양한 데이터를 통합, 분석 및 생성하여 서비스 사용 현황을 시각화하는 "스마트 BI 도구"에 대한 기본 특허 취득',
      content: `<p>TradFit은 다양한 데이터를 통합, 분석 및 생성하여 서비스 사용 현황 시각화를 가능하게 하는 "스마트 BI 도구"에 대한 기본 특허를 취득했습니다.</p>
  <p>이 특허 기술을 통해 기업은 데이터 기반 관리를 가속화하고 보다 효율적인 의사결정을 내릴 수 있습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.24',
      category: '도입 사례 / 발표',
      title: '세계 최초! 모든 데이터를 통합하고 서비스 사용 현황을 시각화하는 비즈니스 인텔리전스 도구! 데이터 기반 관리를 가속화하는 기본 특허(비즈니스 모델 특허) "스마트 BI 도구" 취득',
      content: `<p>TradFit 주식회사는 모든 데이터를 통합하고 서비스 사용 현황을 시각화하는 비즈니스 인텔리전스 도구에 대한 기본 특허(비즈니스 모델 특허) "스마트 BI 도구"를 세계 최초로 취득했습니다.</p>
  <p>이 혁신적인 기술을 통해 기업은 데이터 기반 관리를 가속화하고 보다 효율적인 의사결정을 내릴 수 있습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.23',
      category: '도입 사례 / 발표',
      title: '트래블 보이스 게재. AI 음성 서비스 TradFit, 휴가 렌탈 스마트 홈 시설에서 Amazon Alexa를 활용한 서비스 시작',
      content: `<p>AI 음성 서비스를 제공하는 TradFit이 휴가 렌탈 스마트 홈 시설에서 Amazon Alexa를 활용한 서비스를 시작했습니다.</p>
  <p>이 이니셔티브는 휴가 렌탈 시설의 숙박 경험을 개선하고 효율적인 시설 운영을 실현합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.15',
      category: '도입 사례 / 발표',
      title: '일본 최초, 미나미아오야마의 휴가 렌탈/주거에 숙박 지원 AI 탑재 Amazon Echo 도입 및 서비스 개시',
      content: `<p>TradFit 주식회사는 일본 최초로 미나미아오야마의 휴가 렌탈/주거에 숙박 지원 AI가 탑재된 Amazon Echo를 도입하고 서비스를 시작했습니다.</p>
  <p>이 선진적인 이니셔티브는 고객에게 더욱 쾌적하고 편리한 숙박 경험을 제공합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.24',
      category: '도입 사례 / 발표',
      title: '취득 특허, 트래블 보이스 게재. AI 스피커 TradFit, 예약 기간 동안 다음 숙박 시설을 소개하는 모델 특허 취득',
      content: `<p>AI 스피커를 제공하는 TradFit은 숙박 예약 기간 동안 다음 숙박 시설을 소개하는 비즈니스 모델 특허를 취득했습니다.</p>
  <p>이 기술은 여행객의 편의성을 크게 향상시키고 원활한 여행 경험을 실현합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.19',
      category: '도입 사례 / 발표',
      title: '전 세계 IP 정보를 명쾌하게 해설하는 미디어 IP Media +Vision 게재',
      content: `<p>TradFit 주식회사의 이니셔티브가 전 세계 IP 정보를 명쾌하게 해설하는 미디어 "IP Media +Vision"에 게재되었습니다.</p>
  <p>우리의 혁신적인 특허 기술과 호텔 업계에 대한 기여가 평가받았습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.19',
      category: '도입 사례 / 발표',
      title: '세계 최초! 숙박 예약자가 필요로 하는 경우 숙박 시설을 자동 소개! 비즈니스 모델 특허(기본 특허 기술) "다음 숙박 추천 3" 취득',
      content: `<p>TradFit 주식회사는 숙박 예약자가 필요로 하는 경우 숙박 시설을 자동으로 소개하는 비즈니스 모델 특허(기본 특허 기술) "다음 숙박 추천 3"을 세계 최초로 취득했습니다.</p>
  <p>이 혁신적인 기술을 통해 여행객은 다음 목적지의 숙박 시설을 더욱 쉽고 편리하게 선택할 수 있습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.06',
      category: '도입 사례 / 발표',
      title: '군마현 최초! 호텔 샌더슨, 일본 파스콤 비즈니스 파트너 TradFit이 제공하는 생성형 AI Hospitalia(Amazon ASP for Hospitality) 도입',
      content: `<p>군마현 최초의 이니셔티브로 호텔 샌더슨이 일본 파스콤 비즈니스 파트너 TradFit이 제공하는 생성형 AI "Hospitalia(Amazon ASP for Hospitality)"를 도입했습니다.</p>
  <p>이번 도입으로 호텔 서비스 품질과 운영 효율성이 향상되었습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.05.09',
      category: '도입 사례 / 발표',
      title: '생성형 AI 스피커 "Hospitalia" 도입 사례로 배우는 호텔 업계 인력 부족 해결 방안은?',
      content: `<p>생성형 AI 스피커 "Hospitalia" 도입 사례를 통해 호텔 업계가 직면한 인력 부족 문제를 해결하는 구체적인 방법을 소개합니다.</p>
  <p>실제 도입 시설의 성과와 효과적인 사용 방법을 자세히 설명합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.04.04',
      category: '도입 사례 / 발표',
      title: '생성형 AI 스피커 활용으로 숙박 시설은 어떻게 변화할까? TradFit "Hospitalia" 도입 시설에 묻는 고객 경험부터 백오피스까지의 변화',
      content: `<p>생성형 AI 스피커 활용으로 숙박 시설은 어떻게 변화할까요? TradFit "Hospitalia"를 도입한 시설에 고객 경험부터 백오피스까지의 변화에 대해 자세히 물었습니다.</p>
  <p>현장의 실제 효과와 향후 전망을 소개합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.27',
      category: '도입 사례 / 발표',
      title: 'AI 음성 서비스 TradFit, 스마트 홈 도입 지원 회사와 전략적 제휴 체결, AI 및 IoT 기술 활용하여 인력 부족 해결 추진',
      content: `<p>AI 음성 서비스를 제공하는 TradFit이 스마트 홈 도입 지원 회사와 전략적 제휴를 체결했습니다.</p>
  <p>AI 및 IoT 기술을 활용하여 업계 전반의 인력 부족 문제 해결을 추진합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.27',
      category: '도입 사례 / 발표',
      title: 'TradFit, ao.와 포괄적 업무 제휴 발표! 관광, 숙박, 의료, 지자체 등을 위한 보조금 및 지원금 지원 공동 추진!',
      content: `<p>TradFit 주식회사가 ao.와 포괄적 업무 제휴를 체결했다고 발표했습니다.</p>
  <p>관광, 숙박, 의료, 지자체 등을 위한 다양한 보조금 및 지원금 지원을 공동으로 추진하며 업계 전반의 발전에 기여할 것입니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.26',
      category: '도입 사례 / 발표',
      title: 'TradFit × 산와 텔렘 스마트 홈 시장의 혁신! 포괄적 업무 제휴 발표',
      content: `<p>TradFit 주식회사는 산와 텔렘과 스마트 홈 시장의 혁신을 목표로 포괄적 업무 제휴를 체결했습니다.</p>
  <p>양사의 강점을 활용하여 더욱 쾌적하고 편리한 스마트 홈 환경 실현을 목표로 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.21',
      category: '도입 사례 / 발표',
      title: 'AI 음성 서비스 TradFit, Airbnb 파트너 프로그램 가입, 등록 시설 수익성 향상 지원',
      content: `<p>AI 음성 서비스를 제공하는 TradFit이 Airbnb 파트너 프로그램에 가입했습니다.</p>
  <p>등록 시설의 수익성 향상을 지원하고 고품질 서비스 제공을 실현합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.19',
      category: '도입 사례 / 발표',
      title: 'TradFit, Airbnb Partners 합류 ~Airbnb와 협력하여 숙박 업계 생성형 AI 활용 추진~',
      content: `<p>TradFit 주식회사가 Airbnb Partners에 합류했습니다.</p>
  <p>Airbnb와 협력하고 숙박 업계의 생성형 AI 활용을 추진함으로써 업계 전반의 디지털화를 가속화합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.17',
      category: '도입 사례 / 발표',
      title: '【스타트업 특집】안전한 음성 데이터 플랫폼을 구축하는 TradFit',
      content: `<p>스타트업 특집으로 안전한 음성 데이터 플랫폼 구축을 위한 TradFit 주식회사의 노력을 소개했습니다.</p>
  <p>보안과 편의성을 모두 갖춘 혁신적인 플랫폼에 대해 자세히 설명합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.04',
      category: '도입 사례 / 발표',
      title: '교토 료칸에 숙박 시설용 생성형 AI 스피커 도입, TradFit "Hospitalia"로 무엇을 할 수 있나?',
      content: `<p>교토의 한 료칸에 숙박 시설용 생성형 AI 스피커가 도입되었습니다.</p>
  <p>실제 도입 사례를 통해 TradFit "Hospitalia"로 무엇을 할 수 있는지 자세히 소개합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.03',
      category: '도입 사례 / 발표',
      title: '기업 및 지자체용 "Amazon Alexa"는 문제 과잉 일본 사회에 어떤 변화를 가져올까?',
      content: `<p>기업 및 지자체용 "Amazon Alexa"가 문제 과잉 일본 사회에 어떤 변화를 가져올지 고찰합니다.</p>
  <p>AI 기술 활용은 다양한 사회적 문제 해결에 기여할 것으로 기대됩니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.11.05',
      category: '도입 사례 / 발표',
      title: 'AI 음성 서비스 TradFit, 시설 관리 시스템 연동 및 서비스 이용을 통한 개별화된 대응 자동화 특허 취득',
      content: `<p>AI 음성 서비스를 제공하는 TradFit은 시설 관리 시스템 연동 및 서비스 이용을 통한 개별화된 대응 자동화 특허를 취득했습니다.</p>
  <p>이 기술은 보다 개인화된 서비스 제공을 실현합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.11.01',
      category: '도입 사례 / 발표',
      title: '세계 최초! 호텔, 료칸, 휴가 렌탈, 글램핑 등 숙박 시설 핵심 관리 시스템(PMS)과 투숙객 이용 서비스 연동하여 개인화된 서비스 자동 제공! 비즈니스 모델 특허 "스마트 시스템 연동 2" 취득',
      content: `<p>TradFit 주식회사는 호텔, 료칸, 휴가 렌탈, 글램핑 등 숙박 시설 핵심 관리 시스템(PMS)과 투숙객 이용 서비스를 연동하여 개인화된 서비스를 자동 제공하는 비즈니스 모델 특허 "스마트 시스템 연동 2"을 세계 최초로 취득했습니다.</p>
  <p>이 기술을 통해 숙박 업계 전반의 서비스 품질 향상을 기대하게 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.10.09',
      category: '도입 사례 / 발표',
      title: 'AI 음성 서비스 TradFit, 숙박 관리 시스템 연동을 통한 개별 숙박객 요구 대응 최적화 기본 특허 취득',
      content: `<p>AI 음성 서비스를 제공하는 TradFit은 숙박 관리 시스템 연동을 통한 개별 숙박객 요구 대응 최적화 기본 특허를 취득했습니다.</p>
  <p>숙박 관리 시스템과의 연동을 통해 더욱 개인화된 서비스 제공을 실현합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.10.06',
      category: '도입 사례 / 발표',
      title: '세계 최초! 호텔, 료칸, 휴가 렌탈, 글램핑 등 숙박 시설 핵심 관리 시스템(PMS)과 투숙객 이용 서비스 연동하여 개인화된 서비스 자동 제공! 비즈니스 모델 특허 "스마트 시스템 연동" 취득',
      content: `<p>TradFit 주식회사는 호텔, 료칸, 휴가 렌탈, 글램핑 등 숙박 시설 핵심 관리 시스템(PMS)과 투숙객 이용 서비스를 연동하여 개인화된 서비스를 자동 제공하는 비즈니스 모델 특허 "스마트 시스템 연동"을 세계 최초로 취득했습니다.</p>
  <p>이 기술을 통해 숙박 업계 전반의 서비스 품질 향상을 기대하게 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.09.10',
      category: '도입 사례 / 발표',
      title: '숙박 시설 AI 서비스 TradFit, 음성 요청에 텍스트로 응답하는 특허 취득, 투숙객 및 고령자가 이해하기 쉬워',
      content: `<p>숙박 시설 AI 서비스를 제공하는 TradFit은 음성 요청에 텍스트로 응답하는 특허를 취득했습니다.</p>
  <p>투숙객과 고령자가 이해하기 쉬운 서비스 제공을 실현했습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.09.10',
      category: '도입 사례 / 발표',
      title: '세계 최초! 시끄러운 환경에서도 국내외 투숙객, 고령자, 환자에게 명확하게 안내하는 음성 요청 응답 기능! 기본 특허 "스마트 가이던스" 취득',
      content: `<p>TradFit 주식회사는 시끄러운 환경에서도 국내외 투숙객, 고령자, 환자에게 음성 요청에 응답하여 명확하게 안내하는 기본 특허 "스마트 가이던스"를 세계 최초로 취득했습니다.</p>
  <p>이 기술을 통해 더 많은 사람들에게 편안한 서비스를 제공할 수 있습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.08.20',
      category: '도입 사례 / 발표',
      title: '숙박 시설은 "음성 x 생성형 AI"로 무엇을 할 수 있을까, 호텔 업계 최전선에서 일어나는 변화와 그 효과는? - 트래블 보이스 LIVE 게재 (PR)',
      content: `<p>숙박 시설이 "음성 x 생성형 AI"로 무엇을 할 수 있는지, 호텔 업계 최전선에서 일어나는 변화와 그 효과를 자세히 설명합니다.</p>
  <p>트래블 보이스 LIVE의 기사를 게재합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.07.17',
      category: '도입 사례 / 발표',
      title: '숙박 시설 AI 서비스 TradFit, 한국 IT 투자 회사와 제휴, 기술 활용 "웰니스 관광" 추진',
      content: `<p>숙박 시설 AI 서비스를 제공하는 TradFit이 한국 IT 투자 회사와 제휴하여 기술을 활용한 "웰니스 관광"을 추진합니다.</p>
  <p>웰니스와 관광을 융합한 새로운 여행 경험 창출을 목표로 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.07.17',
      category: '도입 사례 / 발표',
      title: 'MILESEUM과 TradFit, 차세대 첨단 산업 DX 분야(AI, IoT, 로봇, 생체 인식 도어록, 사이니지 등을 활용한 무인화/효율화), 웰니스 관광 등에 관한 포괄적 업무 제휴 체결',
      content: `<p>MILESEUM과 TradFit은 차세대 첨단 산업 DX 분야(AI, IoT, 로봇, 생체 인식 도어록, 사이니지 등을 활용한 무인화/효율화), 웰니스 관광 등에 관한 포괄적 업무 제휴를 체결했습니다.</p>
  <p>양사의 기술과 노하우를 결집하여 산업 혁신을 추진하겠습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.13',
      category: '도입 사례 / 발표',
      title: 'AI 스피커 TradFit, 본인 확인만으로 누구나 매장 개설 가능한 메타버스 공간 구축 플랫폼 특허 취득',
      content: `<p>AI 스피커를 제공하는 TradFit은 메타버스 공간 구축 플랫폼에 대한 특허를 취득했습니다.</p>
  <p>본인 확인만으로 누구나 매장을 개설할 수 있는 혁신적인 플랫폼을 실현했습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.07',
      category: '도입 사례 / 발표',
      title: '숙박 시설 AI 스피커 TradFit, 스마트폰 획득 정보 활용 목적지 최적 호텔 예약 완료 신규 서비스 개시',
      content: `<p>숙박 시설 AI 스피커를 제공하는 TradFit은 스마트폰에서 획득한 정보를 활용하여 목적지의 최적 호텔 예약을 완료하는 신규 서비스를 시작했습니다.</p>
  <p>여행객의 편의성을 대폭 향상시키는 혁신적인 서비스입니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.06',
      category: '도입 사례 / 발표',
      title: '세계 최초! 메타버스 공간 구축 플랫폼! 기본 특허 "스마트 메타버스" 취득',
      content: `<p>TradFit 주식회사는 메타버스 공간 구축 플랫폼에 대한 기본 특허 "스마트 메타버스"를 세계 최초로 취득했습니다.</p>
  <p>이 혁신적인 기술은 새로운 디지털 공간 구축을 가능하게 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.01',
      category: '도입 사례 / 발표',
      title: '숙박 시설 AI 스피커 TradFit, 고객 요청 간편 관리 UI 특허 취득, 운영 개선 지원',
      content: `<p>숙박 시설 AI 스피커를 제공하는 TradFit은 고객 요청을 간편하게 관리할 수 있는 UI 특허를 취득했습니다.</p>
  <p>운영 개선을 지원하고 효율적인 시설 관리를 실현합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.31',
      category: '도입 사례 / 발표',
      title: '세계 최초! 고객 스마트폰 등 획득 목적지 정보 활용 숙박 시설 자동 소개! 기본 특허 "다음 숙박 추천 2" 취득',
      content: `<p>TradFit 주식회사는 고객 스마트폰 등에서 획득한 목적지 정보를 활용하여 숙박 시설을 자동으로 소개하는 기본 특허 "다음 숙박 추천 2"를 세계 최초로 취득했습니다.</p>
  <p>여행객이 다음 목적지의 숙소를 선택하는 것을 지원합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.30',
      category: '도입 사례 / 발표',
      title: '숙박 시설 AI 스피커 TradFit, 음성 통틀어 고객 개별 식별 신기술 특허 취득',
      content: `<p>숙박 시설 AI 스피커를 제공하는 TradFit은 음성을 통해 고객을 개별적으로 식별하는 신기술 특허를 취득했습니다.</p>
  <p>보다 개인화된 서비스 제공이 가능해집니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.30',
      category: '도입 사례 / 발표',
      title: '세계 최초! 간단한 조작으로 고객 요청 명확 관리 혁신적 UI "스마트 요청 관리 UI" 특허 취득',
      content: `<p>TradFit 주식회사는 간단한 조작으로 고객 요청을 명확하게 관리할 수 있는 혁신적인 UI "스마트 요청 관리 UI"에 대한 특허를 세계 최초로 취득했습니다.</p>
  <p>시설 직원의 업무 효율성이 대폭 향상됩니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.24',
      category: '도입 사례 / 발표',
      title: 'TradFit 일본에 이어 필리핀에서 AI 스피커 활용 호텔 객실 온도 최적화 특허 취득',
      content: `<p>TradFit은 일본에 이어 필리핀에서도 AI 스피커를 활용하여 호텔 객실 온도를 최적화하는 특허를 취득했습니다.</p>
  <p>글로벌 확장을 가속화하고 전 세계 숙박 시설에 서비스를 제공하는 것을 목표로 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.24',
      category: '도입 사례 / 발표',
      title: '세계 최초! 어떤 고객의 요청인지 자동 판단! 기본 특허 "스마트 스피커 판단" 취득',
      content: `<p>TradFit 주식회사는 어떤 고객의 요청인지 자동으로 판단하는 기본 특허 "스마트 스피커 판단"을 세계 최초로 취득했습니다.</p>
  <p>보다 정확하고 효율적인 서비스 제공이 가능해집니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.22',
      category: '도입 사례 / 발표',
      title: '세계 최초! 고객을 위해 실내 온도 및 조명 등 객실 환경 자동 최적화! 필리핀에서도 기본 특허 "객실 스마트 제어" 취득',
      content: `<p>TradFit 주식회사는 고객을 위해 실내 온도 및 조명 등 객실 환경을 자동으로 최적화하는 기본 특허 "객실 스마트 제어"를 필리핀에서도 세계 최초로 취득했습니다.</p>
  <p>국际 특허 취득을 통해 글로벌 확장을 가속화합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.11',
      category: '도입 사례 / 발표',
      title: '류구조 스파 호텔 미카즈키 전 객실에 AI 스피커 도입, 생성형 AI 결합 및 스마트 객실 시범 운영',
      content: `<p>류구조 스파 호텔 미카즈키는 전 객실에 AI 스피커를 도입했습니다.</p>
  <p>생성형 AI를 결합하고 스마트 객실을 시범 운영하여 최첨단 호텔 경험을 제공합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.05',
      category: '도입 사례 / 발표',
      title: '류구조 스파 호텔 미카즈키 후지미테이 및 류구테이 전 객실 AI 스피커 도입',
      content: `<p>류구조 스파 호텔 미카즈키의 후지미테이 및 류구테이 전 객실에 AI 스피커를 도입했습니다.</p>
  <p>투숙객에게 더욱 쾌적하고 편리한 숙박 경험을 제공합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.04',
      category: '도입 사례 / 발표',
      title: '홋카이도 최초! TradFit, 도큐 호텔 & 리조트 "삿포로 스트림 호텔"에 Alexa Smart Properties for Hospitality 도입 및 서비스 개시',
      content: `<p>홋카이도 최초의 이니셔티브로 TradFit이 도큐 호텔 & 리조트 "삿포로 스트림 호텔"에 Alexa Smart Properties for Hospitality를 도입하고 서비스를 시작했습니다.</p>
  <p>홋카이도에서 서비스 확장을 시작합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.04',
      category: '도입 사례 / 발표',
      title: '일본 최초 / 업계 최초! TradFit, 호텔 등 모든 숙박 시설 전문 Amazon "Alexa Smart Properties" 솔루션 제공업체 인증 획득',
      content: `<p>일본 최초이자 업계 최초의 성과로 TradFit이 호텔 등 모든 숙박 시설을 전문으로 하는 Amazon "Alexa Smart Properties" 솔루션 제공업체 인증을 획득했습니다.</p>
  <p>이 인증을 통해 더욱 고품질의 서비스를 제공할 수 있게 되었습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.07.29',
      category: '도입 사례 / 발표',
      title: 'UX 및 IoT 분야를 넘나드는 전문가 UX 디자이너 키사이치 미즈키, TradFit 주식회사 CDO 취임',
      content: `<p>UX 및 IoT 분야를 넘나드는 전문가 UX 디자이너 키사이치 미즈키가 TradFit 주식회사의 CDO(Chief Design Officer)로 취임했습니다.</p>
  <p>우리는 탁월한 사용자 경험 제공을 목표로 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.05.06',
      category: '도입 사례 / 발표',
      title: '시이나 시게루, TradFit 고문 취임. 경영 전략 수립, 글로벌 확장 전략, AI 활용 DX 전략 등 강화',
      content: `<p>시이나 시게루가 TradFit 고문으로 취임했습니다.</p>
  <p>경영 전략 수립, 글로벌 확장 전략, AI 활용 DX 전략 등을 강화하고 추가 성장을 목표로 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.04.17',
      category: '도입 사례 / 발표',
      title: '숙박 시설 AI 스피커 TradFit, "ChatGPT" 활용 고객 응대 서비스 개시, 언어 자동 판단으로 다국어 지원',
      content: `<p>숙박 시설 AI 스피커를 제공하는 TradFit은 "ChatGPT"를 활용한 고객 응대 서비스를 시작했습니다.</p>
  <p>언어를 자동으로 판단하고 다국어 지원을 실현합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.04.15',
      category: '도입 사례 / 발표',
      title: 'TradFit, 일본 최초 "ChatGPT 자동 응답 서비스" 베타 버전 제공',
      content: `<p>TradFit 주식회사는 일본 최초로 "ChatGPT 자동 응답 서비스" 베타 버전을 제공하기 시작했습니다.</p>
  <p>이는 최첨단 AI 기술을 활용한 혁신적인 서비스입니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.03.06',
      category: '미디어 게재 / 발표',
      title: '숙박 시설 AI 스피커 TradFit, 아시아 최초 Amazon Alexa Champion 이토 씨 CTO 영입',
      content: `<p>숙박 시설 AI 스피커를 제공하는 TradFit은 아시아 최초 Amazon Alexa Champion 이토 씨를 최고 기술 책임자(CTO)로 영입했습니다.</p>
  <p>우리는 기술 역량을 더욱 강화하는 것을 목표로 합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.02.21',
      category: '도입 사례 / 발표',
      title: '숙박 시설 AI 스피커 TradFit, 객실 환경 자동 최적화 기술 개발, 고객 속성 기반 제어 모드 선택',
      content: `<p>숙박 시설 AI 스피커를 제공하는 TradFit은 객실 환경 자동 최적화 기술을 개발했습니다.</p>
  <p>고객 속성에 따라 제어 모드를 선택하여 더욱 쾌적한 환경을 제공합니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.02.16',
      category: '도입 사례 / 발표',
      title: 'TradFit, 니가타현 혁신 스타트업 "J-Startup NIIGATA" 인증',
      content: `<p>TradFit 주식회사는 니가타현의 혁신적인 스타트업으로서 "J-Startup NIIGATA" 인증을 받았습니다.</p>
  <p>우리는 지역 경제 발전에 기여하는 기업으로 평가받았습니다.</p>
  <p><strong>■ 본 건에 대한 문의</strong><br>TradFit 주식회사<br>E-mail:info@tradift.com</p>`
    }
  ]

};

export default ko;
